import { toast } from '@webapp/components/Notification'
import { getMessageFromError } from '@webapp/core/utils/errors/getMessageFromError'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useQueryUnmatchedCreditCardItems } from '../../models'

export interface IUseUnmatchedCreditCardItemListPresenterParams {
  accountId: number
}

/**
 * Also consumed hook-data-only by the ReconciliationMatchView companion hook
 * for the Unmatched tab badge (BHV-030) — React Query dedupes with the
 * rendered presenter via the shared `unmatched` query config.
 */
export const useUnmatchedCreditCardItemListPresenter = ({
  accountId,
}: IUseUnmatchedCreditCardItemListPresenterParams) => {
  const intl = useProcurifyIntl()

  const { items, unmatchedCount, isLoading } = useQueryUnmatchedCreditCardItems(
    {
      accountId,
      onError: (err) => {
        toast.error({
          title: intl.formatMessage(messages.errorTitle),
          children:
            getMessageFromError(err) ??
            intl.formatMessage(messages.genericErrorMessage),
        })
      },
    }
  )

  return {
    data: {
      items,
      unmatchedCount,
    },
    states: {
      isLoading,
    },
  }
}
